import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
} from "antd";
import {
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import {  GetFeeApprovedList } from "../../../AllAPI/AdminAPI";
import { toast } from "react-toastify";

const RoomAllotmentList = () => {

  const storedBranchId = sessionStorage.getItem("branch_id");
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);


 useEffect(() => {
    fetchRoomApprovedList();
  }, []);

  const fetchRoomApprovedList = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${GetFeeApprovedList}/${storedBranchId}/${BoardingYear}`);

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        wh_mobile: item.wh_mobile || "-",
        room: item.roombooking.room.room_no ||  "-",
        bed: item.roombooking.bed.bed_no ||  "-",
  
        full_data: item,
      }));

      setData(formatted);
    } catch (err) {
      toast.error("Failed to load approved list");
    }finally {
    setLoading(false); // 👉 Stop loader
  }
  };

   // --- SEARCH ---
 const filteredData = data.filter((item) => {
  const search = searchText.toLowerCase();

  return (
    (item.full_name ?? "").toLowerCase().includes(search) 
  );
});


  const columns = [
    { title: "Sr No", dataIndex: "index", width: 80 },
    { title: "Full Name", dataIndex: "full_name" },
    { title: "What's App No.", dataIndex: "wh_mobile" },
    { title: "Room", dataIndex: "room" },
    { title: "Bed", dataIndex: "bed" },
  ];



  return (
    <div className="form-container mainContainer">

     <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">

        <div className="header-row">
          <h2 className="page-title">Room Allotment List</h2>
        </div>

      <div className="search-bar">
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 250 }}
        />
      </div>

      <Table columns={columns} dataSource={filteredData} pagination={{ pageSize: 10 }} bordered loading={loading} scroll={{ x: 'max-content' }} />


      </div>
        <div className="col-12 col-md-2"></div>
      </div>

    </div>
  );
};

export default RoomAllotmentList;
